import TTrialDefaultEntry from './index.vue';

TTrialDefaultEntry.install = app => {
  app.component(TTrialDefaultEntry.name, TTrialDefaultEntry);
};

export default TTrialDefaultEntry;
